module.exports = __webpack_public_path__ + "static/media/mobile-error.0f470938.jpg";